import React from 'react'
import '../css/Values.scss'
import { FiCompass, FiCheckCircle, FiHeart, FiAward, FiZap, FiBookOpen } from 'react-icons/fi'

const Values = () => {
    const Values = [
        {
            letter: 'T',
            value: 'Truth',
            icon: <FiCompass />,
            valueDescription: 'We seek and stand for what is true, in word and in deed.'
        },
        {
            letter: 'H',
            value: 'Honesty',
            icon: <FiCheckCircle />,
            valueDescription: 'We are transparent in our dealings, building trust day by day.'
        },
        {
            letter: 'R',
            value: 'Respect',
            icon: <FiHeart />,
            valueDescription: 'We honour God, ourselves, our families and every person we meet.'
        },
        {
            letter: 'E',
            value: 'Excellence',
            icon: <FiAward />,
            valueDescription: 'We pursue our best in academics, conduct and service.'
        },
        {
            letter: 'A',
            value: 'Accountability',
            icon: <FiZap />,
            valueDescription: 'We take ownership of our actions, choices and results.'
        },
        {
            letter: 'D',
            value: 'Devotion',
            icon: <FiBookOpen />,
            valueDescription: 'We anchor our lives in love for God and commitment to His work.'
        },
    ]
  return (
    <div className='value-section'>
      <div className="page-width">
        <p className='value-section-kicker'>Core Values</p>
        <header className='value-section-header'>The THREAD that holds the school.</header>
        <p className='value-section-subtitle'>Six convictions weave through every classroom, every conversation, every decision at HoneyRock.</p>
        <div className="value-container">
        {
            Values.map((data, index)=>{
                return <div key={index} className='value autoShow'>
                    <span className='value-letter'>{data.letter}</span>
                    <div className='value-icon'>{data.icon}</div>
                    <header className='value-header'>{data.value}</header>
                    <p>{data.valueDescription}</p>
                </div>
            })
        }
        </div>
      </div>
    </div>
  )
}

export default Values
